import { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

export const useIsMergedLotteryPage = (lotteryId: unknown) => {
  const lotteryIdInCorretCase = getLotteryIdInCorrectCase(lotteryId)

  return (
    useIsFeatureFlagEnabled('mergedLotteryPage') &&
    lotteryIdInCorretCase !== LotteryId.NebraskaMyDay &&
    lotteryIdInCorretCase !== LotteryId.PowerBallXsAndOs
  )
}
